<template>
    <div id="multiple-chart" 
        class="multiple-chart"
    >
        <div class="multiple-chart__control">
            <v-select
                v-model="current_zone"
                :items="zone_list"
                id="tsgraph-select-day"
                item-text="text"
                item-value="value"
                :label="zone_label"
            />
            <QpeDatetime
                :props_date="date"
                :props_time="time"
                :name="default_value"
                @update-time="update_time"
                @change-parent-date-time="change_parent_date_time"
            />
        </div>
        <div class="multiple-chart__content">
            <div v-for="({ text, id }, index) in timeseries_select"
                :key="index"
                class="station-chart"
            >
                <div class="station-chart__title">
                    {{ text }}
                </div>
                <MonitorStations v-if="immutable_table_data.length"
                    ref="atlas_chart"
                    :id="id"
                    :station_data="immutable_table_data"
                    :zone_span="zone_span"
                    :zone_table_value="current_zone"
                    :is_show_control_options="false"
                    :rain_init_value="text"
                    :chart_height="225"
                    :is_wrap_tick="true"
                />
            </div>
        </div>
    </div>
</template>

<script>
    import { redirect_monitor_table_ajax, monitor_table_ajax } from "@/utils/monitor/monitor.js"
    import { monitor_mixin } from "@/utils/monitor/monitor_mixin.js"
    import { mapState } from 'vuex'

    import QpeDatetime from "@/components/monitor/qpe_datetime.vue"
    import MonitorStations from "@/components/chart/monitor_stations.vue"

    export default {
        name: 'MultipleChart',

        components: { 
            QpeDatetime,
            MonitorStations,
        },

        mixins: [ monitor_mixin ],
        
        props: {
            sub_title: {
                type: String,
                default () {
                    return ''
                }
            },

            zone_span: {
                type: String,
                required: true,
            },

            option_local_storage_name: {
                type: String,
                required: true,
            }
            
        },      
        
        data() {
            return {
                dialog: false,
                default_dialog_picture: '',
                child_images: {},

                default_value: 41,
                header: [],
                table_data: [],

                // filter使用
                immutable_table_data: [],

                current_zone: '',
                timeseries_select: [
                    {text: '10分鐘', id: 'ten_mins'}, 
                    {text: '1小時', id: 'one_hour'}, 
                    {text: '3小時', id: 'three_hours'}, 
                    {text: '6小時', id: 'six_hours'}, 
                    {text: '12小時', id: 'twelve_hours'}, 
                    {text: '24小時', id: 'one_day'}, 
                ],
            }
        },
        
        computed: {
            zone_label() {
                return `選擇${this.zone_span}`
            },

            zone_list() {
                return this.immutable_table_data.map(datum => datum[this.zone_span])
            },
        },

        watch: {
            zone_list() {
                if(!this.zone_list.includes(this.current_zone)) {
                    const storage_zone_value = localStorage.getItem(this.option_local_storage_name)
                    if (this.zone_list.includes(storage_zone_value)) {
                        this.current_zone = storage_zone_value
                    } else {
                        this.current_zone = this.zone_list[0]
                    }
                }
            },

            current_zone() {
                localStorage.setItem(this.option_local_storage_name, this.current_zone)
            }
        },
        
        created() {
            redirect_monitor_table_ajax.call(this, this.default_value)
        },

        methods: {
            generate_table_data(data, header) {
                this.immutable_table_data = data;
                this.table_data = data;
                this.header = header;
                if(this.$refs.atlas_chart) {
                    this.$refs.atlas_chart.forEach(component => {
                        component.rerender_svg()
                    });
                }
            },

            update_time(new_datetime) {            
                this.is_newest_data = false
                monitor_table_ajax.call(this, this.default_value, new_datetime)
            },

            allow_minutes(minute) {
                return minute % 10 === 0
            },
        },
    }
</script>

<style lang="scss" scoped>
    @import '../../../../css/mixin';

    .multiple-chart {
        &__control {
            display: grid;
            grid-template-columns: repeat(6, 1fr);
            column-gap: .5rem;

            @include laptop {
                grid-template-columns: repeat(3, 1fr);
            }

            @include small-mobile {
                grid-template-columns: 1fr;
            }
        }

        &__content {
            display: grid;
            grid-template-columns: repeat(3, 1fr);
            grid-template-rows: repeat(2, 1fr);
            row-gap: .5rem;
            column-gap: .5rem;

            @include laptop {
                grid-template-columns: repeat(2, 1fr);
            }

            @include mobile {
                grid-template-columns: 1fr;
            }
        }

    }

    .station-chart {
        &__title {
            padding: 6px;
            font-weight: bold;
            text-align: center;
            background: var(--white-bg);
            margin-bottom: 8px;
        }
    }
</style>